"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6648],{

/***/ "./node_modules/@web3modal/core/dist/index.js":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CV": function() { return /* binding */ B; },
  "Id": function() { return /* binding */ v; },
  "t0": function() { return /* binding */ b; },
  "zv": function() { return /* binding */ dist_c; },
  "uA": function() { return /* binding */ _; },
  "uc": function() { return /* binding */ ee; },
  "jb": function() { return /* binding */ te; },
  "zb": function() { return /* binding */ d; },
  "AV": function() { return /* binding */ dist_f; },
  "Ic": function() { return /* binding */ ne; },
  "Vs": function() { return /* binding */ se; },
  "kD": function() { return /* binding */ x; }
});

;// CONCATENATED MODULE: ./node_modules/@web3modal/core/node_modules/proxy-compare/dist/index.modern.js
const e=Symbol(),t=Symbol(),r="a",n="w";let o=(e,t)=>new Proxy(e,t);const s=Object.getPrototypeOf,c=new WeakMap,l=e=>e&&(c.has(e)?c.get(e):s(e)===Object.prototype||s(e)===Array.prototype),f=e=>"object"==typeof e&&null!==e,i=e=>{if(Array.isArray(e))return Array.from(e);const t=Object.getOwnPropertyDescriptors(e);return Object.values(t).forEach(e=>{e.configurable=!0}),Object.create(s(e),t)},u=e=>e[t]||e,a=(s,c,f,p)=>{if(!l(s))return s;let g=p&&p.get(s);if(!g){const e=u(s);g=(e=>Object.values(Object.getOwnPropertyDescriptors(e)).some(e=>!e.configurable&&!e.writable))(e)?[e,i(e)]:[e],null==p||p.set(s,g)}const[y,h]=g;let w=f&&f.get(y);return w&&w[1].f===!!h||(w=((o,s)=>{const c={f:s};let l=!1;const f=(e,t)=>{if(!l){let s=c[r].get(o);if(s||(s={},c[r].set(o,s)),e===n)s[n]=!0;else{let r=s[e];r||(r=new Set,s[e]=r),r.add(t)}}},i={get:(e,n)=>n===t?o:(f("k",n),a(Reflect.get(e,n),c[r],c.c)),has:(t,n)=>n===e?(l=!0,c[r].delete(o),!0):(f("h",n),Reflect.has(t,n)),getOwnPropertyDescriptor:(e,t)=>(f("o",t),Reflect.getOwnPropertyDescriptor(e,t)),ownKeys:e=>(f(n),Reflect.ownKeys(e))};return s&&(i.set=i.deleteProperty=()=>!1),[i,c]})(y,!!h),w[1].p=o(h||y,w[0]),f&&f.set(y,w)),w[1][r]=c,w[1].c=f,w[1].p},p=(e,t,r,o)=>{if(Object.is(e,t))return!1;if(!f(e)||!f(t))return!0;const s=r.get(u(e));if(!s)return!0;if(o){const r=o.get(e);if(r&&r.n===t)return r.g;o.set(e,{n:t,g:!1})}let c=null;try{for(const r of s.h||[])if(c=Reflect.has(e,r)!==Reflect.has(t,r),c)return c;if(!0===s[n]){if(c=((e,t)=>{const r=Reflect.ownKeys(e),n=Reflect.ownKeys(t);return r.length!==n.length||r.some((e,t)=>e!==n[t])})(e,t),c)return c}else for(const r of s.o||[])if(c=!!Reflect.getOwnPropertyDescriptor(e,r)!=!!Reflect.getOwnPropertyDescriptor(t,r),c)return c;for(const n of s.k||[])if(c=p(e[n],t[n],r,o),c)return c;return null===c&&(c=!0),c}finally{o&&o.set(e,{n:t,g:c})}},g=t=>!!l(t)&&e in t,y=e=>l(e)&&e[t]||null,h=(e,t=!0)=>{c.set(e,t)},w=(e,t,r)=>{const o=[],s=new WeakSet,c=(e,l)=>{if(s.has(e))return;f(e)&&s.add(e);const i=f(e)&&t.get(u(e));if(i){var a,p;if(null==(a=i.h)||a.forEach(e=>{const t=`:has(${String(e)})`;o.push(l?[...l,t]:[t])}),!0===i[n]){const e=":ownKeys";o.push(l?[...l,e]:[e])}else{var g;null==(g=i.o)||g.forEach(e=>{const t=`:hasOwn(${String(e)})`;o.push(l?[...l,t]:[t])})}null==(p=i.k)||p.forEach(t=>{r&&!("value"in(Object.getOwnPropertyDescriptor(e,t)||{}))||c(e[t],l?[...l,t]:[t])})}else l&&o.push(l)};return c(e),o},O=e=>{o=e};
//# sourceMappingURL=index.modern.mjs.map

;// CONCATENATED MODULE: ./node_modules/@web3modal/core/node_modules/valtio/esm/vanilla.mjs


const isObject = (x) => typeof x === "object" && x !== null;
const proxyStateMap = /* @__PURE__ */ new WeakMap();
const refSet = /* @__PURE__ */ new WeakSet();
const buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler) => new Proxy(target, handler), canProxy = (x) => isObject(x) && !refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise) => {
  switch (promise.status) {
    case "fulfilled":
      return promise.value;
    case "rejected":
      throw promise.reason;
    default:
      throw promise;
  }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise) => {
  const cache = snapCache.get(target);
  if ((cache == null ? void 0 : cache[0]) === version) {
    return cache[1];
  }
  const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
  h(snap, true);
  snapCache.set(target, [version, snap]);
  Reflect.ownKeys(target).forEach((key) => {
    if (Object.getOwnPropertyDescriptor(snap, key)) {
      return;
    }
    const value = Reflect.get(target, key);
    const desc = {
      value,
      enumerable: true,
      // This is intentional to avoid copying with proxy-compare.
      // It's still non-writable, so it avoids assigning a value.
      configurable: true
    };
    if (refSet.has(value)) {
      h(value, false);
    } else if (value instanceof Promise) {
      delete desc.value;
      desc.get = () => handlePromise(value);
    } else if (proxyStateMap.has(value)) {
      const [target2, ensureVersion] = proxyStateMap.get(
        value
      );
      desc.value = createSnapshot(
        target2,
        ensureVersion(),
        handlePromise
      );
    }
    Object.defineProperty(snap, key, desc);
  });
  return snap;
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [1, 1], proxyFunction = (initialObject) => {
  if (!isObject(initialObject)) {
    throw new Error("object required");
  }
  const found = proxyCache.get(initialObject);
  if (found) {
    return found;
  }
  let version = versionHolder[0];
  const listeners = /* @__PURE__ */ new Set();
  const notifyUpdate = (op, nextVersion = ++versionHolder[0]) => {
    if (version !== nextVersion) {
      version = nextVersion;
      listeners.forEach((listener) => listener(op, nextVersion));
    }
  };
  let checkVersion = versionHolder[1];
  const ensureVersion = (nextCheckVersion = ++versionHolder[1]) => {
    if (checkVersion !== nextCheckVersion && !listeners.size) {
      checkVersion = nextCheckVersion;
      propProxyStates.forEach(([propProxyState]) => {
        const propVersion = propProxyState[1](nextCheckVersion);
        if (propVersion > version) {
          version = propVersion;
        }
      });
    }
    return version;
  };
  const createPropListener = (prop) => (op, nextVersion) => {
    const newOp = [...op];
    newOp[1] = [prop, ...newOp[1]];
    notifyUpdate(newOp, nextVersion);
  };
  const propProxyStates = /* @__PURE__ */ new Map();
  const addPropListener = (prop, propProxyState) => {
    if ( true && propProxyStates.has(prop)) {
      throw new Error("prop listener already exists");
    }
    if (listeners.size) {
      const remove = propProxyState[3](createPropListener(prop));
      propProxyStates.set(prop, [propProxyState, remove]);
    } else {
      propProxyStates.set(prop, [propProxyState]);
    }
  };
  const removePropListener = (prop) => {
    var _a;
    const entry = propProxyStates.get(prop);
    if (entry) {
      propProxyStates.delete(prop);
      (_a = entry[1]) == null ? void 0 : _a.call(entry);
    }
  };
  const addListener = (listener) => {
    listeners.add(listener);
    if (listeners.size === 1) {
      propProxyStates.forEach(([propProxyState, prevRemove], prop) => {
        if ( true && prevRemove) {
          throw new Error("remove already exists");
        }
        const remove = propProxyState[3](createPropListener(prop));
        propProxyStates.set(prop, [propProxyState, remove]);
      });
    }
    const removeListener = () => {
      listeners.delete(listener);
      if (listeners.size === 0) {
        propProxyStates.forEach(([propProxyState, remove], prop) => {
          if (remove) {
            remove();
            propProxyStates.set(prop, [propProxyState]);
          }
        });
      }
    };
    return removeListener;
  };
  const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
  const handler = {
    deleteProperty(target, prop) {
      const prevValue = Reflect.get(target, prop);
      removePropListener(prop);
      const deleted = Reflect.deleteProperty(target, prop);
      if (deleted) {
        notifyUpdate(["delete", [prop], prevValue]);
      }
      return deleted;
    },
    set(target, prop, value, receiver) {
      const hasPrevValue = Reflect.has(target, prop);
      const prevValue = Reflect.get(target, prop, receiver);
      if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) {
        return true;
      }
      removePropListener(prop);
      if (isObject(value)) {
        value = y(value) || value;
      }
      let nextValue = value;
      if (value instanceof Promise) {
        value.then((v) => {
          value.status = "fulfilled";
          value.value = v;
          notifyUpdate(["resolve", [prop], v]);
        }).catch((e) => {
          value.status = "rejected";
          value.reason = e;
          notifyUpdate(["reject", [prop], e]);
        });
      } else {
        if (!proxyStateMap.has(value) && canProxy(value)) {
          nextValue = proxyFunction(value);
        }
        const childProxyState = !refSet.has(nextValue) && proxyStateMap.get(nextValue);
        if (childProxyState) {
          addPropListener(prop, childProxyState);
        }
      }
      Reflect.set(target, prop, nextValue, receiver);
      notifyUpdate(["set", [prop], value, prevValue]);
      return true;
    }
  };
  const proxyObject = newProxy(baseObject, handler);
  proxyCache.set(initialObject, proxyObject);
  const proxyState = [
    baseObject,
    ensureVersion,
    createSnapshot,
    addListener
  ];
  proxyStateMap.set(proxyObject, proxyState);
  Reflect.ownKeys(initialObject).forEach((key) => {
    const desc = Object.getOwnPropertyDescriptor(
      initialObject,
      key
    );
    if ("value" in desc) {
      proxyObject[key] = initialObject[key];
      delete desc.value;
      delete desc.writable;
    }
    Object.defineProperty(baseObject, key, desc);
  });
  return proxyObject;
}) => [
  // public functions
  proxyFunction,
  // shared state
  proxyStateMap,
  refSet,
  // internal things
  objectIs,
  newProxy,
  canProxy,
  defaultHandlePromise,
  snapCache,
  createSnapshot,
  proxyCache,
  versionHolder
];
const [defaultProxyFunction] = buildProxyFunction();
function proxy(initialObject = {}) {
  return defaultProxyFunction(initialObject);
}
function getVersion(proxyObject) {
  const proxyState = proxyStateMap.get(proxyObject);
  return proxyState == null ? void 0 : proxyState[1]();
}
function subscribe(proxyObject, callback, notifyInSync) {
  const proxyState = proxyStateMap.get(proxyObject);
  if ( true && !proxyState) {
    console.warn("Please use proxy object");
  }
  let promise;
  const ops = [];
  const addListener = proxyState[3];
  let isListenerActive = false;
  const listener = (op) => {
    ops.push(op);
    if (notifyInSync) {
      callback(ops.splice(0));
      return;
    }
    if (!promise) {
      promise = Promise.resolve().then(() => {
        promise = void 0;
        if (isListenerActive) {
          callback(ops.splice(0));
        }
      });
    }
  };
  const removeListener = addListener(listener);
  isListenerActive = true;
  return () => {
    isListenerActive = false;
    removeListener();
  };
}
function snapshot(proxyObject, handlePromise) {
  const proxyState = proxyStateMap.get(proxyObject);
  if ( true && !proxyState) {
    console.warn("Please use proxy object");
  }
  const [target, ensureVersion, createSnapshot] = proxyState;
  return createSnapshot(target, ensureVersion(), handlePromise);
}
function ref(obj) {
  refSet.add(obj);
  return obj;
}
const unstable_buildProxyFunction = (/* unused pure expression or super */ null && (buildProxyFunction));



// EXTERNAL MODULE: ./node_modules/buffer/index.js
var buffer = __webpack_require__("./node_modules/buffer/index.js");
;// CONCATENATED MODULE: ./node_modules/@web3modal/core/dist/index.js
let M;const v={ethereumClient:void 0,setEthereumClient(e){M=e},client(){if(M)return M;throw new Error("ClientCtrl has no client set")}},dist_i=proxy({history:["ConnectWallet"],view:"ConnectWallet",data:void 0}),dist_f={state:dist_i,subscribe(e){return subscribe(dist_i,()=>e(dist_i))},push(e,t){e!==dist_i.view&&(dist_i.view=e,t&&(dist_i.data=t),dist_i.history.push(e))},reset(e){dist_i.view=e,dist_i.history=[e]},replace(e){dist_i.history.length>1&&(dist_i.history[dist_i.history.length-1]=e,dist_i.view=e)},goBack(){if(dist_i.history.length>1){dist_i.history.pop();const[e]=dist_i.history.slice(-1);dist_i.view=e}},setData(e){dist_i.data=e}},dist_c={WALLETCONNECT_DEEPLINK_CHOICE:"WALLETCONNECT_DEEPLINK_CHOICE",W3M_VERSION:"W3M_VERSION",RECOMMENDED_WALLET_AMOUNT:9,isMobile(){return typeof window<"u"?!!(window.matchMedia("(pointer:coarse)").matches||/Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)):!1},isAndroid(){return dist_c.isMobile()&&navigator.userAgent.toLowerCase().includes("android")},isIos(){const e=navigator.userAgent.toLowerCase();return dist_c.isMobile()&&(e.includes("iphone")||e.includes("ipad"))},isHttpUrl(e){return e.startsWith("http://")||e.startsWith("https://")},isArray(e){return Array.isArray(e)&&e.length>0},formatNativeUrl(e,t,n){if(dist_c.isHttpUrl(e))return this.formatUniversalUrl(e,t,n);let s=e;s.includes("://")||(s=e.replaceAll("/","").replaceAll(":",""),s=`${s}://`),this.setWalletConnectDeepLink(s,n);const a=encodeURIComponent(t);return`${s}wc?uri=${a}`},formatUniversalUrl(e,t,n){if(!dist_c.isHttpUrl(e))return this.formatNativeUrl(e,t,n);let s=e;e.endsWith("/")&&(s=e.slice(0,-1)),this.setWalletConnectDeepLink(s,n);const a=encodeURIComponent(t);return`${s}/wc?uri=${a}`},async wait(e){return new Promise(t=>{setTimeout(t,e)})},openHref(e,t){window.open(e,t,"noreferrer noopener")},setWalletConnectDeepLink(e,t){localStorage.setItem(dist_c.WALLETCONNECT_DEEPLINK_CHOICE,JSON.stringify({href:e,name:t}))},setWalletConnectAndroidDeepLink(e){const[t]=e.split("?");localStorage.setItem(dist_c.WALLETCONNECT_DEEPLINK_CHOICE,JSON.stringify({href:t,name:"Android"}))},setWeb3ModalVersionInStorage(){typeof localStorage<"u"&&localStorage.setItem(dist_c.W3M_VERSION,"2.3.7")},getWalletRouterData(){var e;const t=(e=dist_f.state.data)==null?void 0:e.Wallet;if(!t)throw new Error('Missing "Wallet" view data');return t},getSwitchNetworkRouterData(){var e;const t=(e=dist_f.state.data)==null?void 0:e.SwitchNetwork;if(!t)throw new Error('Missing "SwitchNetwork" view data');return t}},dist_p=proxy({userSessionId:"",events:[],connectedWalletId:void 0}),_={state:dist_p,subscribe(e){return subscribe(dist_p.events,()=>e(snapshot(dist_p.events[dist_p.events.length-1])))},initialize(){typeof crypto<"u"&&(dist_p.userSessionId=crypto.randomUUID())},setConnectedWalletId(e){dist_p.connectedWalletId=e},click(e){const t={type:"CLICK",name:e.name,userSessionId:dist_p.userSessionId,timestamp:Date.now(),data:e};dist_p.events.push(t)},track(e){const t={type:"TRACK",name:e.name,userSessionId:dist_p.userSessionId,timestamp:Date.now(),data:e};dist_p.events.push(t)},view(e){const t={type:"VIEW",name:e.name,userSessionId:dist_p.userSessionId,timestamp:Date.now(),data:e};dist_p.events.push(t)}},dist_r=proxy({selectedChain:void 0,chains:void 0,standaloneChains:void 0,standaloneUri:void 0,isStandalone:!1,isCustomDesktop:!1,isCustomMobile:!1,isDataLoaded:!1,isUiLoaded:!1,isInjectedMobile:!1,walletConnectVersion:1}),d={state:dist_r,subscribe(e){return subscribe(dist_r,()=>e(dist_r))},setChains(e){dist_r.chains=e},setStandaloneChains(e){dist_r.standaloneChains=e},setStandaloneUri(e){dist_r.standaloneUri=e},getSelectedChain(){const e=v.client().getNetwork().chain;return e&&(dist_r.selectedChain=e),dist_r.selectedChain},setSelectedChain(e){dist_r.selectedChain=e},setIsStandalone(e){dist_r.isStandalone=e},setIsCustomDesktop(e){dist_r.isCustomDesktop=e},setIsCustomMobile(e){dist_r.isCustomMobile=e},setIsDataLoaded(e){dist_r.isDataLoaded=e},setIsUiLoaded(e){dist_r.isUiLoaded=e},setWalletConnectVersion(e){dist_r.walletConnectVersion=e},setIsInjectedMobile(e){dist_r.isInjectedMobile=e}},dist_O=proxy({projectId:"",mobileWallets:void 0,desktopWallets:void 0,walletImages:void 0,chainImages:void 0,tokenImages:void 0,tokenContracts:void 0,standaloneChains:void 0,enableStandaloneMode:!1,enableNetworkView:!1,enableAccountView:!0,enableExplorer:!0,defaultChain:void 0,explorerExcludedWalletIds:void 0,explorerRecommendedWalletIds:void 0,termsOfServiceUrl:void 0,privacyPolicyUrl:void 0}),b={state:dist_O,subscribe(e){return subscribe(dist_O,()=>e(dist_O))},setConfig(e){var t,n,s,a;_.initialize(),d.setStandaloneChains(e.standaloneChains),d.setIsStandalone(!!((t=e.standaloneChains)!=null&&t.length)||!!e.enableStandaloneMode),d.setIsCustomMobile(!!((n=e.mobileWallets)!=null&&n.length)),d.setIsCustomDesktop(!!((s=e.desktopWallets)!=null&&s.length)),d.setWalletConnectVersion((a=e.walletConnectVersion)!=null?a:1),d.state.isStandalone||(d.setChains(v.client().chains),d.setIsInjectedMobile(dist_c.isMobile()&&v.client().isInjectedProviderInstalled())),e.defaultChain&&d.setSelectedChain(e.defaultChain),dist_c.setWeb3ModalVersionInStorage(),Object.assign(dist_O,e)}},dist_o=proxy({address:void 0,profileName:void 0,profileAvatar:void 0,profileLoading:!1,balanceLoading:!1,balance:void 0,isConnected:!1}),B={state:dist_o,subscribe(e){return subscribe(dist_o,()=>e(dist_o))},getAccount(){const e=v.client().getAccount();dist_o.address=e.address,dist_o.isConnected=e.isConnected},async fetchProfile(e,t){var n;try{dist_o.profileLoading=!0;const s=t??dist_o.address,a=(n=d.state.chains)==null?void 0:n.find(l=>l.id===1);if(s&&a){const[l,u]=await Promise.all([v.client().fetchEnsName({address:s,chainId:1}),v.client().fetchEnsAvatar({address:s,chainId:1})]);u&&await e(u),dist_o.profileName=l,dist_o.profileAvatar=u}}finally{dist_o.profileLoading=!1}},async fetchBalance(e){try{const{chain:t}=v.client().getNetwork(),{tokenContracts:n}=b.state;let s;t&&n&&(s=n[t.id]),dist_o.balanceLoading=!0;const a=e??dist_o.address;if(a){const l=await v.client().fetchBalance({address:a,token:s});dist_o.balance={amount:l.formatted,symbol:l.symbol}}}finally{dist_o.balanceLoading=!1}},setAddress(e){dist_o.address=e},setIsConnected(e){dist_o.isConnected=e},resetBalance(){dist_o.balance=void 0},resetAccount(){dist_o.address=void 0,dist_o.isConnected=!1,dist_o.profileName=void 0,dist_o.profileAvatar=void 0,dist_o.balance=void 0}},U="https://explorer-api.walletconnect.com";async function j(e,t){const n=new URL(e,U);return n.searchParams.append("projectId",b.state.projectId),Object.entries(t).forEach(([s,a])=>{a&&n.searchParams.append(s,String(a))}),(await fetch(n)).json()}const C={async getDesktopListings(e){return j("/w3m/v1/getDesktopListings",e)},async getMobileListings(e){return j("/w3m/v1/getMobileListings",e)},async getInjectedListings(e){return j("/w3m/v1/getInjectedListings",e)},async getAllListings(e){return j("/w3m/v1/getAllListings",e)},getWalletImageUrl(e){return`${U}/w3m/v1/getWalletImage/${e}?projectId=${b.state.projectId}`},getAssetImageUrl(e){return`${U}/w3m/v1/getAssetImage/${e}?projectId=${b.state.projectId}`}};var H=Object.defineProperty,N=Object.getOwnPropertySymbols,K=Object.prototype.hasOwnProperty,z=Object.prototype.propertyIsEnumerable,k=(e,t,n)=>t in e?H(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,J=(e,t)=>{for(var n in t||(t={}))K.call(t,n)&&k(e,n,t[n]);if(N)for(var n of N(t))z.call(t,n)&&k(e,n,t[n]);return e};const D=dist_c.isMobile(),dist_g=proxy({wallets:{listings:[],total:0,page:1},injectedWallets:[],search:{listings:[],total:0,page:1},recomendedWallets:[]}),ee={state:dist_g,async getRecomendedWallets(){const{explorerRecommendedWalletIds:e,explorerExcludedWalletIds:t}=b.state;if(e==="NONE"||t==="ALL"&&!e)return dist_g.recomendedWallets;if(dist_c.isArray(e)){const n={recommendedIds:e.join(",")},{listings:s}=await C.getAllListings(n),a=Object.values(s);a.sort((l,u)=>{const w=e.indexOf(l.id),y=e.indexOf(u.id);return w-y}),dist_g.recomendedWallets=a}else{const{standaloneChains:n,walletConnectVersion:s}=d.state,a=n?.join(","),l=dist_c.isArray(t),u={page:1,entries:dist_c.RECOMMENDED_WALLET_AMOUNT,chains:a,version:s,excludedIds:l?t.join(","):void 0},{listings:w}=D?await C.getMobileListings(u):await C.getDesktopListings(u);dist_g.recomendedWallets=Object.values(w)}return dist_g.recomendedWallets},async getWallets(e){const t=J({},e),{explorerRecommendedWalletIds:n,explorerExcludedWalletIds:s}=b.state,{recomendedWallets:a}=dist_g;if(s==="ALL")return dist_g.wallets;t.search||(a.length?t.excludedIds=a.map($=>$.id).join(","):dist_c.isArray(n)&&(t.excludedIds=n.join(","))),dist_c.isArray(s)&&(t.excludedIds=[t.excludedIds,s].filter(Boolean).join(","));const{page:l,search:u}=e,{listings:w,total:y}=D?await C.getMobileListings(t):await C.getDesktopListings(t),L=Object.values(w),S=u?"search":"wallets";return dist_g[S]={listings:[...dist_g[S].listings,...L],total:y,page:l??1},{listings:L,total:y}},async getInjectedWallets(){const{listings:e}=await C.getInjectedListings({}),t=Object.values(e);return dist_g.injectedWallets=t,dist_g.injectedWallets},getWalletImageUrl(e){return C.getWalletImageUrl(e)},getAssetImageUrl(e){return C.getAssetImageUrl(e)},resetSearch(){dist_g.search={listings:[],total:0,page:1}}},E=proxy({pairingUri:"",pairingError:!1}),x={state:E,subscribe(e){return subscribe(E,()=>e(E))},setPairingUri(e){E.pairingUri=e},setPairingError(e){E.pairingError=e}},W=proxy({open:!1}),te={state:W,subscribe(e){return subscribe(W,()=>e(W))},async open(e){return new Promise(t=>{const{isStandalone:n,isUiLoaded:s,isDataLoaded:a}=d.state,{pairingUri:l}=x.state,{isConnected:u}=B.state,{enableNetworkView:w}=b.state;if(n?(d.setStandaloneUri(e?.uri),d.setStandaloneChains(e?.standaloneChains),dist_f.reset("ConnectWallet")):e!=null&&e.route?dist_f.reset(e.route):u?dist_f.reset("Account"):w?dist_f.reset("SelectNetwork"):dist_f.reset("ConnectWallet"),s&&a&&(n||l||u))W.open=!0,t();else{const y=setInterval(()=>{const L=d.state,S=x.state;L.isUiLoaded&&L.isDataLoaded&&(L.isStandalone||S.pairingUri||u)&&(clearInterval(y),W.open=!0,t())},200)}})},close(){W.open=!1}};var q=Object.defineProperty,P=Object.getOwnPropertySymbols,F=Object.prototype.hasOwnProperty,G=Object.prototype.propertyIsEnumerable,T=(e,t,n)=>t in e?q(e,t,{enumerable:!0,configurable:!0,writable:!0,value:n}):e[t]=n,Q=(e,t)=>{for(var n in t||(t={}))F.call(t,n)&&T(e,n,t[n]);if(P)for(var n of P(t))G.call(t,n)&&T(e,n,t[n]);return e};function X(){return typeof matchMedia<"u"&&matchMedia("(prefers-color-scheme: dark)").matches}const A=proxy({themeMode:X()?"dark":"light"}),ne={state:A,subscribe(e){return subscribe(A,()=>e(A))},setThemeConfig(e){const{themeMode:t,themeVariables:n}=e;t&&(A.themeMode=t),n&&(A.themeVariables=Q({},n))}},I=proxy({open:!1,message:"",variant:"success"}),se={state:I,subscribe(e){return subscribe(I,()=>e(I))},openToast(e,t){I.open=!0,I.message=e,I.variant=t},closeToast(){I.open=!1}};typeof window<"u"&&(window.Buffer||(window.Buffer=buffer/* Buffer */.lW),window.global||(window.global=window),window.process||(window.process={env:{}}));
//# sourceMappingURL=index.js.map


/***/ }),

/***/ "./node_modules/@web3modal/standalone/dist/index.js":
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Web3Modal": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var _web3modal_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@web3modal/core/dist/index.js");
var c=Object.defineProperty,i=Object.getOwnPropertySymbols,d=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,a=(o,e,t)=>e in o?c(o,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):o[e]=t,m=(o,e)=>{for(var t in e||(e={}))d.call(e,t)&&a(o,t,e[t]);if(i)for(var t of i(e))b.call(e,t)&&a(o,t,e[t]);return o};class f{constructor(e){this.openModal=_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .ModalCtrl.open */ .jb.open,this.closeModal=_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .ModalCtrl.close */ .jb.close,this.subscribeModal=_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .ModalCtrl.subscribe */ .jb.subscribe,this.setTheme=_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .ThemeCtrl.setThemeConfig */ .Ic.setThemeConfig,_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .ThemeCtrl.setThemeConfig */ .Ic.setThemeConfig(e),_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .ConfigCtrl.setConfig */ .t0.setConfig(m({enableStandaloneMode:!0},e)),this.initUi()}async initUi(){if(typeof window<"u"){await __webpack_require__.e(/* import() */ 9797).then(__webpack_require__.bind(__webpack_require__, "./node_modules/@web3modal/ui/dist/index.js"));const e=document.createElement("w3m-modal");document.body.insertAdjacentElement("beforeend",e),_web3modal_core__WEBPACK_IMPORTED_MODULE_0__/* .OptionsCtrl.setIsUiLoaded */ .zb.setIsUiLoaded(!0)}}}
//# sourceMappingURL=index.js.map


/***/ })

}]);